import React from "react";
import { Target, Users, Video, MessageCircle } from "lucide-react";

function Services() {
  const services = [
    {
      icon: Target,
      title: "1-on-1 Coaching",
      description:
        "Personalized coaching sessions tailored to your specific goals and challenges.",
      features: [
        "Goal Setting",
        "Action Planning",
        "Accountability",
        "Progress Tracking",
      ],
    },
    {
      icon: Users,
      title: "Group Coaching",
      description:
        "Connect with like-minded individuals in a supportive group environment.",
      features: [
        "Peer Support",
        "Shared Learning",
        "Group Dynamics",
        "Cost Effective",
      ],
    },
    {
      icon: Video,
      title: "Online Workshops",
      description:
        "Interactive workshops covering various life coaching topics and skills.",
      features: [
        "Live Sessions",
        "Recorded Content",
        "Workbooks",
        "Community Access",
      ],
    },
    {
      icon: MessageCircle,
      title: "Digital Support",
      description: "Ongoing support through messaging and digital resources.",
      features: [
        "Text Support",
        "Resource Library",
        "Progress Check-ins",
        "Quick Questions",
      ],
    },
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">My Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the coaching approach that best fits your needs and
            lifestyle. All services are designed to support your personal growth
            journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow"
            >
              <div className="text-center mb-6">
                <div className="bg-purple-100 rounded-full p-4 inline-block mb-4">
                  <service.icon className="h-8 w-8 text-purple-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm">{service.description}</p>
              </div>

              <ul className="space-y-2 mb-6">
                {service.features.map((feature, idx) => (
                  <li
                    key={idx}
                    className="flex items-center text-sm text-gray-600"
                  >
                    <div className="w-2 h-2 bg-purple-600 rounded-full mr-2"></div>
                    {feature}
                  </li>
                ))}
              </ul>

              <div className="text-center">
                {/* <div className="text-2xl font-bold text-purple-600 mb-4">
                  {service.price}
                </div> */}
                {/* <button className="w-full bg-purple-600 text-white py-2 px-4 rounded-lg hover:bg-purple-700 transition-colors">
                  Get Started
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
